export const positionMap: Record<
  "bottom-right" | "bottom-left" | "top-right" | "top-left",
  string
> = {
  "bottom-right": "persona-bottom-6 persona-right-6",
  "bottom-left": "persona-bottom-6 persona-left-6",
  "top-right": "persona-top-6 persona-right-6",
  "top-left": "persona-top-6 persona-left-6"
};








